<template>
    <div class="section section--gallery section--red-gradient section--myvodafone-download">
        <div class="spring spring--lg">
            <div class="my-vodafone-app">
                <div class="my-vodafone-app__image">
                    <img src="https://static.vodafone.ro/roaming/images/v546107.png" alt="My Vodafone App Phone" />
                </div>
                <div class="my-vodafone-app__body">
                    <div class="media media--gutter media--auto media--middle gutter--bottom">
                        <div class="media__body">
                            <h3 class="heading heading--3 heading--leading heading--trailing">
                                Pentru ajutor,
                                <br />accesează aplicaţia
                                <strong>My Vodafone</strong>
                            </h3>
                        </div>
                    </div>
                    <a href="https://play.google.com/store/apps/details?id=ro.vodafone.mcare.android" target="_blank">
                        <img src="https://static.vodafone.ro/roaming/images/v267756.png" alt="Descarcă din Google Play" height="38px;" />
                    </a>
                    <a href="https://itunes.apple.com/ro/app/my-vodafone-romania/id468772675" target="_blank">
                        <img src="https://static.vodafone.ro/roaming/images/v267755.png" alt="Descarcă din App Store" height="38px;" />
                    </a>
                    <p>Sau apelează &nbsp;<img src="https://static.vodafone.ro/roaming/images/v546151.png" alt="" style="vertical-align: middle" /> <strong>00 4037 202 222</strong> din reţeaua Vodafone</p>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
export default {
    name: 'MyVodafoneDownload',
};
</script>
